/* ============================================================
   SHOPFLO-001 (2026-08-25) - make Shopflo own the cart, as on live theme
   161128382702.

   THREE THINGS THE LIVE THEME HAS THAT 9.2.0 REMOVED

   1. Shopflo's classes in the header markup. Live sections/header.liquid was
      hand-edited to add flo-header-cart-btn and a
      <span id="cart-count-bubble" class="flo-cart-icon-bubble">. Those classes
      ARE the integration contract - the bridge engages when it finds them.

   2. The cart drawer registered in the aside group. 9.2.0 moved the drawer out
      of header.liquid into its own section; it was never added to
      sections/group-overlay.json. With NO drawer in the DOM the theme's
      product form falls back to a native submit and the browser lands on
      /cart - the Shopify cart page. Fixed in group-overlay.json.

   3. Shopflo intercepting the add itself. On live the flo classes are present
      in the HTML at parse time, so the bridge is wired before the theme binds
      its own handlers, and the THEME DRAWER NEVER OPENS. Here the classes are
      applied by JS after the fact, so the theme wins the race and opens its
      own drawer - which is the "Shopify cart" that kept appearing.

      Since header.liquid (27,808) and mobile-menu.liquid (40,515) are past the
      write ceiling, the markup cannot be fixed at source. Instead the theme
      drawer is closed the instant it opens and Shopflo's cart is opened in its
      place. Deterministic, and it does not depend on winning a race.

   ROLLBACK: delete this file and its <script> line in layout/theme.liquid.
   ============================================================ */
(function () {
  'use strict';

  var TOGGLE = '.cart__toggle';
  var FLO_BTN = 'flo-header-cart-btn';
  var BUBBLE = 'flo-cart-icon-bubble';
  var ADD_SEL = '[data-add-to-cart], [data-add-to-cart-secondary], [name="add"], .btn-quick-buy';
  var DRAWER_OPEN = 'js-drawer-open-cart';

  function decorate() {
    document.querySelectorAll(TOGGLE).forEach(function (a) {
      if (!a.classList.contains(FLO_BTN)) a.classList.add(FLO_BTN);
      if (!a.querySelector('.' + BUBBLE)) {
        var s = document.createElement('span');
        s.id = 'cart-count-bubble';
        s.className = BUBBLE + ' hidden';
        s.setAttribute('aria-hidden', 'true');
        a.appendChild(s);
      }
      var wrap = a.parentElement;
      if (wrap && wrap.classList.contains('menu__item') && !wrap.classList.contains(FLO_BTN)) {
        wrap.classList.add(FLO_BTN);
      }
    });
  }

  function styles() {
    if (document.getElementById('adorn-flo-bubble-css')) return;
    var s = document.createElement('style');
    s.id = 'adorn-flo-bubble-css';
    s.textContent =
      TOGGLE + '{position:relative;}' +
      '.' + BUBBLE + '{position:absolute;top:-2px;right:-4px;min-width:17px;height:17px;' +
      'padding:0 4px;border-radius:999px;background:#d02e2e;color:#fff;' +
      'font-family:var(--FONT-STACK-BODY,sans-serif);font-size:10px;font-weight:700;' +
      'line-height:17px;text-align:center;letter-spacing:0;text-transform:none;' +
      'pointer-events:none;box-sizing:border-box;z-index:2;' +
      'box-shadow:0 0 0 2px var(--COLOR-BG,#fff);}' +
      '.' + BUBBLE + '.hidden,.' + BUBBLE + '[hidden]{display:none;}';
    document.head.appendChild(s);
  }

  function stop(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }

  function openFlo() {
    if (typeof window.handleFloCartBtn === 'function') window.handleFloCartBtn();
  }

  /* The theme drawer must never be the visible cart. Close it the moment it
     opens and show Shopflo instead. Guarded so we do not fight the theme in a
     loop if Shopflo is unavailable - in that case the drawer is left alone,
     which is better than no cart at all. */
  var suppressing = false;
  function suppressThemeDrawer() {
    if (suppressing) return;
    if (typeof window.handleFloCartBtn !== 'function') return;
    suppressing = true;

    var el = document.querySelector('cart-items#cart-drawer, cart-items[data-cart-drawer]');
    if (el && typeof el.closeCartDrawer === 'function') {
      el.closeCartDrawer();
    } else {
      document.body.classList.remove(DRAWER_OPEN);
    }

    openFlo();
    setTimeout(function () { suppressing = false; }, 600);
  }

  new MutationObserver(function () {
    if (document.body.classList.contains(DRAWER_OPEN)) suppressThemeDrawer();
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('button[name="checkout"], #checkout2, .cart__checkout, [data-checkout-button]')) {
      if (typeof window.handleFloCheckoutBtn === 'function') {
        stop(e);
        window.handleFloCheckoutBtn();
      }
      return;
    }

    if (t.closest('#flo-buy-now-button, [name="flo-buy-now-button"]')) {
      if (typeof window.handleFloBuyNowBtn === 'function') {
        stop(e);
        window.handleFloBuyNowBtn(e);
      }
      return;
    }

    if (t.closest('.' + FLO_BTN + ', ' + TOGGLE + ', [data-cart-drawer-toggle]')) {
      if (typeof window.handleFloCartBtn === 'function') {
        stop(e);
        openFlo();
      }
      return;
    }

    if (t.closest(ADD_SEL)) {
      // The theme opens its drawer on success; the observer above swaps it for
      // Shopflo. Nothing to do here beyond letting the add proceed.
    }
  }, true);

  function boot() {
    styles();
    decorate();
    new MutationObserver(function () { decorate(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
    boot();
  } else {
    boot();
  }
})();
